// Base URL is URL for backend, make sure that url should be not end with slash ( / )

let BASE_URL;
export let FRONTEND_URL;
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    BASE_URL = "https://api.trevex.io";
    FRONTEND_URL = "https://trevex.io";
} else if (process.env.REACT_APP_ENVIRONMENT === 'testing') {
    BASE_URL = "https://testapi.trevex.io";
    FRONTEND_URL = "https://test.trevex.io";
} else {
    BASE_URL = "http://127.0.0.1:8000";
    FRONTEND_URL = "http://localhost:3000";
}

export const SITE_URL = BASE_URL;
export const BILLING_URL = `${BASE_URL}/api/billing`;
export const COMPANY_URL = `${BASE_URL}/api/company`;
export const LOCAL_URL = `${BASE_URL}/api`;
// TIP-609 — Counterparty Briefs. The backend mounts this collection under
// /api/briefs, NOT under /api/company/<companyID>/counterparty-briefs as the
// contract document drafted it; the company is a `company_id` query parameter
// instead. Endpoints hang off this base.
export const BRIEFS_URL = `${BASE_URL}/api/briefs`;
export const BANK_URL = "https://swiftcodesapi.com/v1";
export const WORLDBOX_URL = "http://testapi.worldbox.ch/v1";

